import { render, staticRenderFns } from "./sysModulePreview.vue?vue&type=template&id=3c33589b&"
import script from "./sysModulePreview.vue?vue&type=script&lang=js&"
export * from "./sysModulePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports